angular.module('westBerkshireEvents.filter').filter('canUseClientDetails', function() {
    return function(question, client) {
        // Strip out the adult flag if it is present
        let name = question.name.split(' (Adult)')[0].trim();
        // Determine whether this questions matches a default client field
        return name.toLowerCase() == 'first name' || name.toLowerCase() == 'last name'
    };
});


// WEBPACK FOOTER //
// src/public/javascripts/filter/can_use_client_details.filter.js